import { render, staticRenderFns } from "./ApplicationStatusChange.vue?vue&type=template&id=4b4e299e&scoped=true"
import script from "./ApplicationStatusChange.vue?vue&type=script&lang=js"
export * from "./ApplicationStatusChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e299e",
  null
  
)

export default component.exports